import { useEffect, useRef, useState } from "react";
import type { Stage } from "../../types/domain";

interface Props {
  onAdd: (stage: Stage) => void;
  disabled?: boolean;
}

const STAGES: Array<{ id: Stage; label: string; color: string; hint: string }> = [
  { id: "warmup", label: "Прогрев", color: "var(--stage-warmup)", hint: "Дни до эфиров" },
  { id: "sales", label: "Продажи / эфир", color: "var(--stage-sales)", hint: "День прямого эфира" },
  { id: "close", label: "Дожим / закрытие", color: "var(--stage-close)", hint: "После эфиров" },
];

export function AddDayColumn({ onAdd, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div className="column add-day-column" ref={ref}>
      {!open ? (
        <button
          type="button"
          className="add-day-cta"
          onClick={() => setOpen(true)}
          disabled={disabled}
        >
          <div className="add-day-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.8}
              strokeLinecap="round"
            >
              <path d="M5 12h14M12 5v14" />
            </svg>
          </div>
          <b>Добавить день</b>
          <span>В конец таймлайна</span>
        </button>
      ) : (
        <div className="add-day-panel">
          <div className="add-day-panel-title">Какой этап?</div>
          {STAGES.map((s) => (
            <button
              key={s.id}
              type="button"
              className="add-day-stage"
              onClick={() => {
                if (disabled) return;
                onAdd(s.id);
                setOpen(false);
              }}
              disabled={disabled}
            >
              <span className="stage-dot" style={{ background: s.color }} />
              <div>
                <b>{s.label}</b>
                <span>{s.hint}</span>
              </div>
            </button>
          ))}
          <button type="button" className="add-day-cancel" onClick={() => setOpen(false)}>
            Отмена
          </button>
        </div>
      )}
    </div>
  );
}
